import { render, staticRenderFns } from "./products.page.vue?vue&type=template&id=215a5a57&scoped=true"
import script from "./products.page.vue?vue&type=script&lang=js"
export * from "./products.page.vue?vue&type=script&lang=js"
import style0 from "./products.page.vue?vue&type=style&index=0&id=215a5a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a5a57",
  null
  
)

export default component.exports